import React, { useContext } from 'react';
import FileExchangeComponent from '../../components/FileExchangeComponent';
import { Panel } from '../../components/Panel';
import IconComponent from '../../components/IconComponent';
import { AppContext } from "../../context/AppContext";

/**
 * FileExchange
 * @constructor
 */
export function FileExchange() {
  const {
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * render
   */
  return (
        <>
          <Panel
            header={
              <>
                <IconComponent iconName={ ROUTE_CONFIG.FILE_EXCHANGE.icon } />
                { ROUTE_CONFIG.FILE_EXCHANGE.title }
              </>
            }
          >
            <FileExchangeComponent />
          </Panel>
        </>
  );
}
